import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';

const appendScale = (url: string, scale?: number) => {
  if (!scale) {
    return url;
  }

  const separator = url.indexOf('?') === -1 ? '?' : '&';
  return `${url}${separator}scale=${scale}`;
};

const toResponse = (response: any) => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }

  return response.result;
};

export default (api: AxiosInstance, url: string) => async (
  link: string,
  scale?: number
) => {
  const urlWithId = appendScale(insertId(url, encodeURIComponent(link)), scale);
  const response = await api.get(urlWithId);
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/link/getQR.ts